export default "__VITE_ASSET__CU3iT24x__"